import { render, staticRenderFns } from "./sign-proposal.vue?vue&type=template&id=15468908&scoped=true"
import script from "./sign-proposal.vue?vue&type=script&lang=ts"
export * from "./sign-proposal.vue?vue&type=script&lang=ts"
import style0 from "./sign-proposal.vue?vue&type=style&index=0&id=15468908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15468908",
  null
  
)

export default component.exports